export const PROFILE_PIC_UPDATED_EVENT = "nco:profile-pic-updated";

export function notifyProfilePicUpdated() {
    window.dispatchEvent(new CustomEvent(PROFILE_PIC_UPDATED_EVENT));
}
